<template>
  <svg
    enable-background="new 0 0 512 512"
    height="512"
    viewBox="0 0 512 512"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M108 26 h198 l98 98 v362 h-296 z m26 26 v408 h244 v-324 h-88 v-84 z m182 18 v40 h40 z" />
    <path d="M164 200 h124 v26 h-124 z" />
    <path d="M164 262 h184 v26 h-184 z" />
    <path d="M164 324 h184 v26 h-184 z" />
    <path d="M164 386 h124 v26 h-124 z" />
  </svg>
</template>
